import React from 'react';
import { motion } from 'framer-motion';
export function Testimonial() {
  return <section className="relative py-40 px-6 lg:px-8 bg-white overflow-hidden" data-id="element-208">
      {/* Subtle gradient accents - light version */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.2
    }} className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-[#0F52BA]/5 to-transparent rounded-full blur-3xl" animate={{
      y: [0, -30, 0],
      x: [0, 20, 0]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-209" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.2,
      delay: 0.2
    }} className="absolute bottom-0 right-0 w-[700px] h-[700px] bg-gradient-to-tl from-[#06B6D4]/5 to-transparent rounded-full blur-3xl" animate={{
      y: [0, 30, 0],
      x: [0, -20, 0]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-210" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-211">
        {/* Main quote */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mb-20" data-id="element-212">
          <blockquote data-id="element-213">
            <motion.p initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.5
          }} className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.15] mb-8" style={{
            fontFamily: 'Space Grotesk, sans-serif'
          }} data-id="element-214">
              <span style={{
              color: 'var(--color-navy)'
            }} data-id="element-215">
                "I always recommend Dilpreet, Darrell and their team to senior
                leaders who need a partner they can{' '}
              </span>
              <span className="bg-gradient-to-r from-[#0F52BA] to-[#06B6D4] bg-clip-text text-transparent" data-id="element-216">
                trust and absolutely rely on
              </span>
              <span style={{
              color: 'var(--color-navy)'
            }} data-id="element-217">
                {' '}
                to deliver against complex, high impact business challenges."
              </span>
            </motion.p>
          </blockquote>
        </motion.div>

        {/* Floating attribution card */}
        <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="inline-block ml-auto" data-id="element-218">
          <div className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-2xl p-8 shadow-xl" data-id="element-219">
            <div className="flex items-start gap-6" data-id="element-220">
              {/* Decorative gradient line */}
              <div className="w-1 h-24 bg-gradient-to-b from-[#0F52BA] to-[#06B6D4] rounded-full" data-id="element-221" />

              <div data-id="element-222">
                <motion.p initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.6,
                delay: 1
              }} className="text-2xl font-bold mb-2" style={{
                fontFamily: 'Space Grotesk, sans-serif',
                color: 'var(--color-navy)'
              }} data-id="element-223">
                  Dr. Felicia Guity
                </motion.p>

                <motion.p initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.6,
                delay: 1.1
              }} className="text-base text-gray-600 mb-1" data-id="element-224">
                  COO Google Cloud, Systems Reliability Engineering
                </motion.p>

                <motion.p initial={{
                opacity: 0,
                x: -10
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.6,
                delay: 1.2
              }} className="text-lg font-semibold bg-gradient-to-r from-[#0F52BA] to-[#06B6D4] bg-clip-text text-transparent" data-id="element-225">
                  Google
                </motion.p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}